import { ref, type Ref } from "vue";

const CORNER_HIDDEN_STORAGE_KEY = "ai_widget_hidden_in_corner";

const readStoredCornerHidden = (): boolean => {
    try {
        return (
            window.localStorage.getItem(CORNER_HIDDEN_STORAGE_KEY) === "true"
        );
    } catch {
        return false;
    }
};

const writeStoredCornerHidden = (isHidden: boolean): void => {
    try {
        if (isHidden === true) {
            window.localStorage.setItem(CORNER_HIDDEN_STORAGE_KEY, "true");
        } else {
            window.localStorage.removeItem(CORNER_HIDDEN_STORAGE_KEY);
        }
    } catch {
        // Blocked storage (private mode) keeps the state for this page life only.
    }
};

/** Persisted "hidden in the hot corner" state of the Ask AI widget launcher. */
export function useAiWidgetCornerHide(): {
    isHiddenInCorner: Ref<boolean>;
    hideToCorner: () => void;
    revealFromCorner: () => void;
} {
    const isHiddenInCorner = ref(readStoredCornerHidden());

    const hideToCorner = (): void => {
        isHiddenInCorner.value = true;
        writeStoredCornerHidden(true);
    };

    const revealFromCorner = (): void => {
        if (isHiddenInCorner.value === false) {
            return;
        }
        isHiddenInCorner.value = false;
        writeStoredCornerHidden(false);
    };

    return { isHiddenInCorner, hideToCorner, revealFromCorner };
}
